import { closeAllTwoFaOverlays } from "@features/two-fa/close-all-overlays";

import { closeAllOverlayInstances } from "@shared/ui/chakra/overlays/close-all-overlay-instances";
import { spinnerOverlay } from "@shared/ui/chakra/overlays/spinner";

export const closeAllOpenOverlays = () => {
  closeAllTwoFaOverlays();
  closeAllOverlayInstances(spinnerOverlay);
};
